import React from 'react';
import './backfillcheck.css';
import { useTranslation } from "react-i18next";

export default function BackFillCheck({ openBackFillPopup, closeBackFillPopup }) {
  const { t } = useTranslation("clientBooking");
  return (
    <div className="bfc-wrap">
      <h4 className="bfc-title">{t("backfill.chooser.title")}</h4>
      <p className="bfc-sub">{t("backfill.chooser.subtitle")}</p>

      <div className="bfc-cards">
        {/* Start now */}
        <div className="bfc-card bfc-card--active">
          <div className="bfc-card-top">
            <div className="bfc-icon-wrap">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#d5a67b" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
              </svg>
            </div>
            <div className="bfc-card-body">
              <p className="bfc-card-title">{t("backfill.chooser.nowTitle")}</p>
              <p className="bfc-card-desc">{t("backfill.chooser.nowDesc")}</p>
              <span className="bfc-badge bfc-badge--green">
                <span className="bfc-badge-dot bfc-badge-dot--green" />
                {t("backfill.chooser.nowBadge")}
              </span>
            </div>
          </div>
          <button className="bfc-btn bfc-btn--solid" onClick={openBackFillPopup}>
            {t("backfill.chooser.nowButton")}
          </button>
        </div>

        {/* "OR" divider between the two options */}
        <div className="bfc-or-line" aria-hidden="true" />
        <div className="bfc-or-badge" aria-hidden="true">{t("backfill.chooser.or")}</div>

        {/* Book in advance */}
        <div className="bfc-card">
          <div className="bfc-card-top">
            <div className="bfc-icon-wrap bfc-icon-wrap--gray">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
              </svg>
            </div>
            <div className="bfc-card-body">
              <p className="bfc-card-title bfc-card-title--dark">{t("backfill.chooser.futureTitle")}</p>
              <p className="bfc-card-desc">{t("backfill.chooser.futureDesc")}</p>
              <span className="bfc-badge bfc-badge--tan">
                <span className="bfc-badge-dot bfc-badge-dot--tan" />
                {t("backfill.chooser.futureBadge")}
              </span>
            </div>
          </div>
          <button className="bfc-btn bfc-btn--outline" onClick={closeBackFillPopup}>
            {t("backfill.chooser.futureButton")}
          </button>
        </div>
      </div>
    </div>
  );
}
